exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imballi-card[data-v-465c3d58]{display:none;width:100%;background-color:#f5f5f5;margin:2px 0}", ""]);

// exports
